import React from "react";
import { bool, oneOf, string } from "prop-types";
import { TabCol } from "./Grid";
import TabTitle from "./Title";

const TabItem = ({
	tabType = 1,
	active = false,
	tabClassName,
	cell = "medium-shrink",
	...props
}) => {
	return (
		<TabCol className={tabClassName} cell={cell}>
			<TabTitle tabType={tabType} active={active} {...props} />
		</TabCol>
	);
};

TabItem.propTypes = {
	cell: string,
	tabType: oneOf([1, 2]),
	tabClassName: string,
	active: bool,
	...TabTitle.propTypes,
};

export default TabItem;
